var Education = "التعليم";
var Enterprise = "للمؤسسات";
var CompanyType = {
	"Company type": "نوع الشركة",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "الحكومات الفيدرالية",
	"Government - State & local": "حكومات الولاية والحكومات المحلية",
	"Non-profit": "المؤسسات غير الربحية",
	"Self employed": "الأشخاص ذوو المهن الحرة",
	"Small-medium business": "الشركات الصغيرة والمتوسطة",
	"Start-up": "الشركات الناشئة",
	"Not applicable": "غير قابل للتطبيق"
};

export { Education, Enterprise, CompanyType as default };
